import { Link } from 'react-router-dom';
import { ArrowRight, Phone, Mail, MapPin } from 'lucide-react';
import { SERVICES, CONTACT } from '@/content/site';
import { Magnetic } from './motion';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden" style={{ background: '#050f0c' }}>
      <div className="aura aura--emerald" style={{ width: 560, height: 560, top: -220, right: -160 }} />
      <div className="wrap py-20 lg:py-24 relative">
        <div className="grid gap-14 lg:grid-cols-[1.4fr_1fr_1fr_1.15fr]">
          <div>
            <span className="logo-chip">
              <img
                src="/images/ktk-logo-tight.png"
                alt="KTK Advisors"
                width="1284"
                height="386"
                className="h-10 w-auto"
                loading="lazy"
              />
            </span>
            <p className="mt-7 text-[15px] leading-relaxed text-mist max-w-[36ch]">
              KTK Advisors is a founder-led advisory practice helping businesses
              uncover cost-saving opportunities, improve efficiency, and pursue
              growth.
            </p>
            <Magnetic className="mt-8">
              <Link to="/contact" data-testid="footer-cta-button" className="btn btn-gold !py-3.5 !px-7 text-[13.5px]">
                Schedule a Consultation
                <ArrowRight size={16} />
              </Link>
            </Magnetic>
          </div>

          <nav aria-label="Services">
            <h3 className="font-mono text-[10.5px] font-medium uppercase tracking-[0.28em] text-goldbright">
              Services
            </h3>
            <ul className="mt-6 space-y-3.5">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={s.path}
                    data-testid={`footer-service-${s.slug}`}
                    className="text-[14.5px] text-ivory/75 hover:text-goldbright transition-colors"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Company">
            <h3 className="font-mono text-[10.5px] font-medium uppercase tracking-[0.28em] text-goldbright">
              Company
            </h3>
            <ul className="mt-6 space-y-3.5">
              <li><Link to="/about" data-testid="footer-about-link" className="text-[14.5px] text-ivory/75 hover:text-goldbright transition-colors">About</Link></li>
              <li><Link to="/solutions" data-testid="footer-solutions-link" className="text-[14.5px] text-ivory/75 hover:text-goldbright transition-colors">Solutions</Link></li>
              <li><Link to="/our-approach" data-testid="footer-approach-link" className="text-[14.5px] text-ivory/75 hover:text-goldbright transition-colors">Our Approach</Link></li>
              <li><Link to="/contact" data-testid="footer-contact-link" className="text-[14.5px] text-ivory/75 hover:text-goldbright transition-colors">Contact</Link></li>
              <li><Link to="/privacy" data-testid="footer-privacy-link" className="text-[14.5px] text-ivory/75 hover:text-goldbright transition-colors">Privacy Policy</Link></li>
            </ul>
          </nav>

          <div>
            <h3 className="font-mono text-[10.5px] font-medium uppercase tracking-[0.28em] text-goldbright">
              Contact
            </h3>
            <ul className="mt-6 space-y-5 text-[14.5px] text-ivory/75">
              <li className="flex items-start gap-3">
                <Phone size={16} className="mt-0.5 text-goldbright flex-none" />
                <a href={CONTACT.phoneHref} data-testid="footer-phone-link" className="hover:text-goldbright transition-colors">
                  {CONTACT.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 text-goldbright flex-none" />
                <a href={CONTACT.emailHref} data-testid="footer-email-link" className="hover:text-goldbright transition-colors break-all">
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-goldbright flex-none" />
                <span>
                  {CONTACT.address1}
                  <br />
                  {CONTACT.address2}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-gold/15 flex flex-col sm:flex-row justify-between gap-4 text-[13px] text-ivory/45">
          <p>© {year} KTK Advisors. All rights reserved.</p>
          <Link to="/privacy" data-testid="footer-bottom-privacy-link" className="hover:text-goldbright transition-colors">
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
}
